import {useMemo, useContext} from 'react'
import {generateBreadcrumbLinkContent} from './utils'
import {BuilderContext} from '@builder.io/sdk-react'

export const useParentPageCrumbs = ({isParentPageType}) => {
    const builderContext = useContext(BuilderContext)

    const currentPageData = useMemo(
        () => ({value: builderContext?.content}),
        [builderContext?.content]
    )

    const parentPageCrumbs = useMemo(() => {
        if (!isParentPageType) {
            return []
        }
        const crumbs = []
        let pageData = currentPageData

        while (pageData?.value?.data) {
            const isCurrentPage = pageData.value.data.url == currentPageData.value.data.url
            const crumbContent = generateBreadcrumbLinkContent({
                pageData,
                isClickable: !isCurrentPage
            })
            crumbs.unshift(crumbContent)

            if (pageData.value.data.parentPage) {
                pageData = pageData.value.data.parentPage
            } else {
                pageData = null
            }
        }

        return crumbs
    }, [currentPageData, isParentPageType])

    return {parentPageCrumbs}
}
